import datacentral from '@/utils/axios/datacentral'
import {
    CreateTechnicalTemplatePayload,
    TechnicalTemplate,
    UpdateTechnicalTemplatePayload,
} from '../types'
import { ResponseArray, ResponseObject } from '@/types/shared'

const BASE_URL = '/technical-templates'

// Get all templates
export const getAllTechnicalTemplates = async (): Promise<
    TechnicalTemplate[]
> => {
    const response =
        await datacentral.get<ResponseArray<TechnicalTemplate>>(BASE_URL)
    return response.data.results || []
}

// Get templates by product group (accepts both ID and name)
export const getTechnicalTemplatesByProductGroup = async (
    productGroupIdOrName: number | string
): Promise<TechnicalTemplate[]> => {
    const response = await datacentral.get<ResponseArray<TechnicalTemplate>>(
        `${BASE_URL}/product-group/${productGroupIdOrName}`
    )
    return response.data.results || []
}

// Get single template
export const getTechnicalTemplateById = async (
    templateId: number
): Promise<TechnicalTemplate> => {
    const response = await datacentral.get<ResponseObject<TechnicalTemplate>>(
        `${BASE_URL}/${templateId}`
    )
    return response.data.result
}

// Create template
export const createTechnicalTemplate = async (
    payload: CreateTechnicalTemplatePayload
): Promise<TechnicalTemplate> => {
    const response = await datacentral.post<ResponseObject<TechnicalTemplate>>(
        BASE_URL,
        payload
    )
    return response.data.result
}

// Update template
export const updateTechnicalTemplate = async (
    templateId: number,
    payload: UpdateTechnicalTemplatePayload
): Promise<TechnicalTemplate> => {
    const response = await datacentral.put<ResponseObject<TechnicalTemplate>>(
        `${BASE_URL}/${templateId}`,
        payload
    )
    return response.data.result
}

// Delete template
export const deleteTechnicalTemplate = async (
    templateId: number
): Promise<void> => {
    await datacentral.delete(`${BASE_URL}/${templateId}`)
}
